export const ds_FeatureTilesBlock_Entry = `
    fragment ds_FeatureTilesBlock_Entry on ds_FeatureTilesBlock_Entry {
        id
        canonicalUid

        featureTiles_ContainerWidth
        featureTiles_TopSpacing
        featureTiles_ColorTheme
        featureTiles_ColorPalette
        featureTiles_FullWidthBackground

        featureTiles_HeadingAndTextPosition
        featureTiles_HeadingAndTextAlignment
        featureTiles_DividerLines

        featureTiles_TileFormat

        featureTiles_SubHeading
        featureTiles_Heading
        featureTiles_BodyText
        featureTiles_Button {
            text
            target
            url
            ... on featureTiles_Button_Custom_LinkType {
                buttonStyle
            }
            ... on featureTiles_Button_Entry_LinkType {
                buttonStyle
            }
            ... on featureTiles_Button_Url_LinkType {
                buttonStyle
            }
            ... on featureTiles_Button_Phone_LinkType {
                buttonStyle
            }
            ... on featureTiles_Button_Email_LinkType {
                buttonStyle
            }
        }
        featureTiles_TileItems {
            ... on ds_TilesItem_Entry {
                canonicalUid
                tileItem_ImageType

                tileItem_Subheading
                tileItem_Heading
                tileItem_TextOnHover

                tileItem_TextPosition
                tileItem_TextSize

                tileItem_ApplyFillToTile
                tileItem_BorderAroundTile

                tileItem_ColorTheme
                tileItem_ColorPalette

                tileItem_Image {
                    url @transform(width: 500, height: 500)
                    alt
                    focalPoint
                }
                tileItem_Link {
                    text: linkText
                    target
                    url
                    ariaLabel
                }
            }
        }
    }
`
